import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider } from './context/ThemeContext';
import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import Feedback from './pages/Feedback';
import Webinar from './pages/Webinar';
import Webinarredirect from './pages/Webinarredirect';
import Webinarsuccess from './pages/Webinarsuccess';
import SertifikatForm from './pages/SertifikatForm';
import Login from './pages/Login';
import Register from './pages/Register';
import WebinarPaymentDetail from './pages/WebinarPaymentDetail';
import PostWebinar from './pages/PostWebinar';
import VideoGrid from './pages/VideoGrid';
import Kelas from './pages/Kelas';
import Spesial17 from './pages/Spesial17';
import Spesial17Form from './pages/Spesial17Form';
import MerdekaDownload from './pages/MerdekaDownload';
import MyWebinars from './pages/MyWebinars';
import Profile from './pages/Profile';
import Templating from './components/Templating';

// Learning module pages
import LearningLayout from './pages/learning/LearningLayout';
import EpisodeList from './pages/learning/EpisodeList';
import EpisodeView from './pages/learning/EpisodeView';
import MaterialList from './pages/learning/MaterialList';
import TranscriptView from './pages/learning/TranscriptView';
import QuizPage from './pages/learning/QuizPage';
import CertificatePage from './pages/learning/CertificatePage';

import api from './api/axios';

// Map route patterns to human-readable page titles
function getPageTitle(pathname) {
  const routes = [
    { pattern: /^\/$/, title: 'Home' },
    { pattern: /^\/about/, title: 'About Me' },
    { pattern: /^\/feedback/, title: 'Feedback' },
    { pattern: /^\/webinar\/redirect\//, title: 'Webinar Redirect' },
    { pattern: /^\/webinar\/success\//, title: 'Webinar Success' },
    { pattern: /^\/webinar-payments\//, title: 'Webinar Payment Detail' },
    { pattern: /^\/webinar/, title: 'Webinar' },
    { pattern: /^\/sertifikat\//, title: 'Sertifikat Form' },
    { pattern: /^\/login/, title: 'Login' },
    { pattern: /^\/register/, title: 'Register' },
    { pattern: /^\/post-webinar/, title: 'Post Webinar' },
    { pattern: /^\/video/, title: 'Video Grid' },
    { pattern: /^\/my-classes/, title: 'My Classes' },
    { pattern: /^\/kelas/, title: 'Kelas' },
    { pattern: /^\/promo-merdeka/, title: 'Merdeka' },
    { pattern: /^\/merdeka/, title: 'Merdeka' },
    { pattern: /^\/learning\/[^/]+\/episodes\/[^/]+/, title: 'Episode View' },
    { pattern: /^\/learning\/[^/]+\/episodes/, title: 'Episode List' },
    { pattern: /^\/learning\/[^/]+\/materials/, title: 'Materials' },
    { pattern: /^\/learning\/[^/]+\/transcripts/, title: 'Transcripts' },
    { pattern: /^\/learning\/[^/]+\/quiz/, title: 'Quiz' },
    { pattern: /^\/learning\/[^/]+\/certificate/, title: 'Certificate' },
    { pattern: /^\/learning\//, title: 'Learning Module' },
  ];

  for (const route of routes) {
    if (route.pattern.test(pathname)) {
      return route.title;
    }
  }
  return pathname;
}



function PageTracker() {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;
    // Don't track if path hasn't changed
    if (prevPath.current === currentPath) return;
    prevPath.current = currentPath;

    const pageTitle = getPageTitle(currentPath);
    api.post('/api/page-visit', { path: currentPath, page_title: pageTitle })
      .catch(() => {
        // Silently ignore tracking errors
      });
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <PageTracker />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutMe />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/webinar" element={<Webinar />} />
        <Route path="/webinar/redirect/:idtransaction" element={<Webinarredirect />} />
        <Route path="/webinar/success/:idtransaction/:nilai" element={<Webinarsuccess />} />
        <Route path="/sertifikat/:webinarId/:idPeserta/:namaPeserta/:noHp" element={<SertifikatForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/webinar-payments/:id/:nomorhp" element={<WebinarPaymentDetail />} />
        <Route path="/post-webinar" element={<PostWebinar />} />
        <Route path="/video" element={<VideoGrid />} />
        <Route path="/kelas" element={<Kelas />} />
        <Route path="/merdeka" element={<MerdekaDownload />} />
        <Route path="/merdeka/daftar" element={<Navigate to="/promo-merdeka/daftar" replace />} />
        <Route path="/promo-merdeka" element={<Spesial17 />} />
        <Route path="/promo-merdeka/daftar" element={<Spesial17Form />} />

        {/* Protected member routes */}
        <Route path="/my-classes" element={
          <ProtectedRoute><MyWebinars /></ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute><Profile /></ProtectedRoute>
        } />

        {/* Learning module - nested routes */}
        <Route path="/learning/:webinarId" element={
          <ProtectedRoute><ThemeProvider><LearningLayout /></ThemeProvider></ProtectedRoute>
        }>
          <Route index element={<EpisodeList />} />
          <Route path="episodes" element={<EpisodeList />} />
          <Route path="episodes/:epId" element={<EpisodeView />} />
          <Route path="materials" element={<MaterialList />} />
          <Route path="transcripts" element={<TranscriptView />} />
          <Route path="quiz" element={<QuizPage />} />
          <Route path="certificate" element={<CertificatePage />} />
        </Route>
      </Routes>
      <Templating />
    </Router>
  );
}

export default App;
